<script lang="ts" setup>
import {
  computed,
  useCommonIdEventData,
  useRoute,
  useTemplateRef,
  watch,
} from '#imports';
import { message } from 'ant-design-vue';
import { useService } from '@kaokei/use-vue-service';
import { useElementVisibility } from '@vueuse/core';
import { useAdvancedDraggable } from '~/composables/use-advanced-draggable';
import { ImService } from '../im.service';
import ImHeader from './ImHeader.vue';
import ImSender from './ImSender.vue';
import MediaInputHub from './MediaInputHub.vue';
import ImMsgList from './msg/ImMsgList.vue';

const route = useRoute();
const service = useService(ImService);
const chatBoxRef = useTemplateRef<HTMLElement>('draggable-target');
const chatBoxVisible = useElementVisibility(chatBoxRef);

const [messageApi, contextHolder] = message.useMessage({
  top: 80,
  getContainer: () => chatBoxRef.value as HTMLElement,
});
service.messageApi = messageApi; // 初始化messageApi

const { isDragging, style } = useAdvancedDraggable({
  handle: 'draggable-handle',
  target: chatBoxRef,
  container: 'draggable-container',
  bottom: 48,
  right: 48,
});
function handleSendImgMsgByFile(file: File) {
  service.messageService.sendImgMsgByFile(file);
}

const eventData = useCommonIdEventData();
const pageEvent = computed(() => ({
  ...eventData,
  page_name: route.name,
}));

let startShowTime = Date.now();
watch(chatBoxVisible, (visible) => {
  if (visible) {
    // 记录显示聊天框的时间
    startShowTime = Date.now();
    window.hetaoTrack('oj_show_im_window', pageEvent.value);
  } else {
    // 记录隐藏聊天框的时间
    const endTime = Date.now();
    const duration = endTime - startShowTime;
    startShowTime = endTime;
    const data = {
      duration,
      ...pageEvent.value,
    };
    window.hetaoTrack('oj_hide_im_window', data);
  }
});
</script>

<template>
  <div
    ref="draggable-target"
    :style="style"
    class="im-chat-box fixed z-40 h-[90vh] max-h-[780px] min-h-[270px] w-[560px] overflow-hidden rounded-xl border border-colorFill shadow-[0px_0px_20px_0px_rgba(0,0,0,0.1)]"
  >
    <MediaInputHub
      class="flex h-full w-full flex-col"
      :on-file="handleSendImgMsgByFile"
    >
      <ImHeader
        ref="draggable-handle"
        :class="isDragging ? 'cursor-grabbing' : 'cursor-grab'"
      />
      <ImMsgList />
      <ImSender />

      <Teleport to="body">
        <div
          ref="draggable-container"
          class="pointer-events-none fixed left-0 top-0 -z-10 h-full w-full"
        ></div>
      </Teleport>
    </MediaInputHub>
    <context-holder />
  </div>
</template>

<style scoped>
.im-chat-box {
  border-width: 0.5px;
}

.im-chat-box :deep(.ant-message) {
  position: absolute !important;
}
</style>
